/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Vehicle_Gps_History_SegmentsInputs */

const vi_vehicle_gps_history_segments = /** @type {(inputs: Vehicle_Gps_History_SegmentsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} chặng hành trình`)
};

/**

* @param {Vehicle_Gps_History_SegmentsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_gps_history_segments = /** @type {((inputs: Vehicle_Gps_History_SegmentsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Gps_History_SegmentsInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_gps_history_segments(inputs)
});